import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    templateUrl: './confirm-message.component.html',
    styleUrls: ['./confirm-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmMessageComponent {
  isConfirmed: boolean = false;

  constructor(
    private matSnackBarRef: MatSnackBarRef<ConfirmMessageComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {

   }

  ok(): void {
    this.isConfirmed = true;
    this.dismiss();
  }

  cancel(): void {
    this.isConfirmed = false;
    this.dismiss();
  }

  private dismiss(): void {
    this.matSnackBarRef.dismiss();
  }
}
